<div id="main-content">
  <div class="container-fluid">
    <app-breadcrumb [dataInput]="breadCrumb"></app-breadcrumb>


    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card">
          <div class="header">
            <h2>List of Transaction Types</h2>
            <!--<div class="float-right">
              <button type="button" class="btn btn-outline-primary btn-sm" (click)="openDialog('zoneModal')">
                <i class="fa fa-plus"></i> &nbsp;<span>Create Zone</span></button>
            </div>-->
          </div>
          <div class="body mt-2">
            <div class="text-center mt-1 mb-3" *ngIf="loadingData"><span class="fa fa-spin fa-spinner fa-2x"></span>&nbsp; Loading, Please wait...</div>
            <div class="table-responsive" *ngIf="showData">
              <table id="all-transaction-types" class="table table-bordered table-hover table-striped dataTable" cellspacing="0" width="100%">
                <thead>
                <tr >
                  <th>S/N</th>
                  <th>Type</th>
                  <th>Description</th>
                  <th>Status</th>
                </tr>
                </thead>
                <tfoot>
                <tr >
                  <th>S/N</th>
                  <th>Type</th>
                  <th>Description</th>
                  <th>Status</th>
                </tr>
                </tfoot>
                <tbody>

                <tr *ngFor="let transType of allTransTypes;let i = index;">
                  <td>{{ i + 1 }}</td>
                  <td>{{ transType?.transaction_type }}</td>
                  <td>{{ transType?.transaction_description }}</td>
                  <td>
                    <span *ngIf="transType?.is_active" class="badge badge-success">Active</span>
                    <span *ngIf="!transType?.is_active" class="badge badge-warning">Inactive</span>
                  </td>
                  <!--<td>
                    <div>
                      <span role="button" data-balloon="Edit Zone" data-balloon-pos="up" (click)="triggerEdit(zone)">
                        <i class="fa fa-edit text-info"></i>
                      </span>&nbsp;&nbsp;
                      <span role="button" data-balloon="Delete Zone" data-balloon-pos="up" (click)="deleteZone(zone)">
                        <i class="fa fa-trash text-danger"></i>
                      </span>
                    </div>
                  </td>-->
                </tr>
                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>

    </div>



  </div>
</div>

